import React from 'react';
import Lottie from 'lottie-react';
import calooshaLoading from './calooshaLoading.json';
import loadingAnimation from './loadingAnimation.json';
import rippleLoad from './rippleLoad.json';
import { motion } from 'framer-motion';
import PageTransitionWrapper from '../PageTransitionWrapper';
import { fadeIn, slideUpFromBottom } from '../../helpers/animation';
const FullPageLoading = () => {
  return (
    <PageTransitionWrapper>
      <main className="flex h-screen w-full items-center justify-center">
        <motion.div
          className="w-[300px]"
          variants={fadeIn}
          initial="hidden"
          animate="visible"
        >
          <Lottie animationData={calooshaLoading} loop />
        </motion.div>
      </main>
    </PageTransitionWrapper>
  );
};

export default FullPageLoading;
